export default "__VITE_ASSET__BhfSME_7__"